import { render } from "./ProjectAssets.vue?vue&type=template&id=6b7b8364"
import script from "./ProjectAssets.vue?vue&type=script&lang=js"
export * from "./ProjectAssets.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__